const imageMimeTypes = {
  avif: 'image/avif',
  heic: 'image/heic',
  heif: 'image/heif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp'
}
const hdrImageMimeTypes = new Set(['image/avif', 'image/heic', 'image/heif'])

// canRetryImageFallback 兼容图与失败地址不同时才允许切换
export const canRetryImageFallback = (failedURL, fallbackURL, baseURL) => {
  if (!fallbackURL) return false
  try {
    return new URL(failedURL, baseURL).href !== new URL(fallbackURL, baseURL).href
  } catch {
    // 非法备用地址直接结束等待，交由调用方展示失败状态
    return false
  }
}

const fileExtension = (value = '') => {
  const path = String(value).split(/[?#]/, 1)[0]
  const dot = path.lastIndexOf('.')
  return dot >= 0 ? path.slice(dot + 1).toLowerCase() : ''
}

/**
 * selectAlbumMediaSources 仅为 Safari 保留 HEIF，其他浏览器使用已有预览
 * @param {{ displayURL: string, fallbackURL: string, hdrSources: Array<{ url: string, type: string }> }} sources
 */
export const selectAlbumMediaSources = (sources, preferOriginalHDR = false) => {
  if (preferOriginalHDR) return sources
  const displayURL = ['heic', 'heif'].includes(fileExtension(sources.displayURL)) ? '' : sources.displayURL
  const fallbackURL = ['heic', 'heif'].includes(fileExtension(sources.fallbackURL)) ? displayURL : sources.fallbackURL
  return {
    displayURL,
    fallbackURL,
    hdrSources: sources.hdrSources.filter(source => source.type === 'image/avif')
  }
}

export const resolveAlbumMediaSources = (item = {}) => {
  const originalURL = String(item.url || '').trim()
  const displayURL = String(item.displayUrl || originalURL).trim()
  const fallbackURL = String(item.fallbackUrl || displayURL || originalURL).trim()
  const hdrSources = []
  if (item.isHDR) {
    const seen = new Set()
    const sourceURLs = [originalURL, displayURL]
    sourceURLs.forEach((url) => {
      const type = imageMimeTypes[fileExtension(url)] || ''
      if (!url || !hdrImageMimeTypes.has(type) || seen.has(url)) {
        return
      }
      seen.add(url)
      hdrSources.push({ url, type })
    })
  }
  return {
    displayURL,
    fallbackURL,
    hdrSources
  }
}

// resolveAlbumLightboxURL 优先展示图，仅为 Safari 保留 HDR HEIF 原图
export const resolveAlbumLightboxURL = (item = {}, preferOriginalHDR = false) => {
  const sources = selectAlbumMediaSources(resolveAlbumMediaSources(item), preferOriginalHDR)
  const original = sources.hdrSources.find(source => source.type === 'image/heic' || source.type === 'image/heif')
  return original?.url || sources.displayURL || sources.fallbackURL
}

export const isAppleSafari = (userAgent = '', vendor = '') => {
  const ua = String(userAgent)
  return /Apple/i.test(String(vendor)) &&
    /Safari/i.test(ua) &&
    !/(Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android)/i.test(ua)
}

export const isTouchOnlyInput = matchMedia => Boolean(
  matchMedia('(hover: none) and (pointer: coarse)').matches
)
